<template>
  <div>
    <h1>Мастера</h1>
    <white-bg padding="0" class="first_screen">
      <row class="row">
        <grid-item xs="12" xl="4" class="side" v-if="isVisibleMasters">
          <search class="side__search" @input="searchInput" v-model="search" placeholder="Имя или номер телефона"/>
          <button @click="registerMaster" v-if="!createModal">Зарегистрировать мастера</button>
          <div class="side__previews" style="margin-top: 10px">
            <list @change="(sort) => {payload = sort; getMaster()}" @activeMaster="activeMaster" :masters="masters" :sortType="sortType"/>
            <h4 v-if="!masters.length" style="text-align: center">Список пуст</h4>
            <preload-content :loading="loading">
              <div class="more" v-if="this.page !== this.lastPage">
                <button @click="getMaster(true)">Еще мастера</button>
              </div>
            </preload-content>
          </div>
        </grid-item>
        <div class="body" v-if="isVisibleClientInfo">
          <white-bg class="client-side">
            <div class="wrap">
              <div :style="{'display': (createModal ? '' : 'none')}" v-if="createModal">
                <create @back="mastersVisible = true"/>
              </div>
              <div v-else>
                <info
                    v-if="masterSelected"
                    :master="masterSelected"
                    @back="mastersVisible = true"
                    @new-contract="setContract"
                    @authorize="authorize"
                    @updated="updateMaster"
                />
              </div>
            </div>
          </white-bg>
        </div>
      </row>
    </white-bg>
  </div>
</template>

<script>
import WhiteBg from '@/components/ui/white-bg'
import Row from '@/components/grid/Row'
import GridItem from '@/components/grid/GridItem'
import Search from '@/components/ui/inputs/custom-search'
import List from './MastersList'
import Info from './Info'
import Create from "@/pages/Cabinet/Admin/Master/Create"
import preloadContent from "@/components/ui/preload-content"

export default {
  name: 'AdministratorMasters',
  components: {Info, List, Row, WhiteBg, GridItem, Search, Create, preloadContent},
  data: () => ({
    loading: false,
    createModal: true,
    page: 1,
    search: '',
    masters: [],
    masterSelected: '',
    lastPage: 1,
    isHidden: false,
    mastersVisible: true,
    sortType: 'register_date',
    payload: {}
  }),
  methods: {
    activeMaster(idx) {
      this.createModal = false
      this.masters.map((val, ind) => {
        val.isActive = idx === ind;
        if (val.isActive) this.masterSelected = val;
        return val;
      });
      this.mastersVisible = false;
    },
    updateMaster(master) {
      this.masters.map((val) => {
        if (master.id == val.id) {
          val = master;
          if (this.masterSelected.id == master.id) this.$set(this, 'masterSelected', master);
        }
        return val;
      });
    },
    searchInput(data) {
      this.search = data;
      this.resetData();
      this.getMaster();
    },
    resetData() {
      this.masters = []
      this.page = 1
      this.lastPage = 1
    },
    getMasterFilter() {
      return {
        page: this.page,
        search: this.search,
        ...this.payload
      }
    },
    getMaster(more = false) {
      if (more) this.page += 1
      this.loading = true
      this.$api.admin.masterList(this.getMasterFilter()).then((response) => {
        if (more) this.masters.push.apply(this.masters, response.data);
        else this.masters = response.data;
        this.lastPage = response.meta.last_page
        // if(this.masters.length) this.activeMaster(0);
      }).finally(() => this.loading = false)
    },
    registerMaster() {
      this.mastersVisible = false
      this.createModal = true
    },
    setContract(masterId, contract) {
      this.masters.map(val => {
        if (val.id === masterId) val.contract = contract
        return val
      })
    },
    authorize(masterId, authorize) {
      this.masters.map(val => {
        if (val.id === masterId) val.authorized_at = authorize
        return val
      })
    },
  },
  computed: {
    isMobile() {
      return document.documentElement.clientWidth < 1170
    },
    isVisibleMasters() {
      if (!this.isMobile) return true
      return this.mastersVisible
    },
    isVisibleClientInfo() {
      if (!this.isMobile) return true
      return !this.mastersVisible
    }
  },
  beforeMount() {
    this.getMaster()
  },
  mounted() {
    this.$eventHub.$on('master.verify.add.list', () => {
      this.resetData()
      this.getMaster()
    })
  },
  beforeDestroy() {
    this.$eventHub.$off('master.verify.add.list')
  }
}
</script>

<style scoped lang="scss">
.more {
  margin-top: 10px;
  margin-bottom: 10px;

  button {
    margin: 0 auto;
    display: flex;
    align-items: center;
    border: none;
    background-color: transparent;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #B9765B;

    &:after {
      content: '';
      width: 20px;
      height: 20px;
      margin-left: 5px;
      background-image: url("../../../../assets/images/icons/chevron-down.svg");
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
}

h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #383838;
  left: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.body {
  width: 66.66%;
}

.whiteBg {
  padding: 0;

  &.client-side {
    height: 100%;
    background: rgba(219, 191, 167, 0.3);
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    outline: hidden;
    margin-right: 15px;

    .wrap {
      padding: 30px;
      height: 100%;
    }
  }
}

.input {
  display: flex;
  justify-content: center;
  border-top: 1px solid #E5E5E5;
  padding: 15px 15px 0 15px;
}

.side {
  border-right: 1px solid #E5E5E5;
  padding: 0 0;

  &__search {
    margin-left: 15px;
    border-bottom: 1px solid #E5E5E5;;
  }

  &__previews {
    overflow-y: scroll;
    height: 60vh;
    margin-left: 15px;
  }

  button {
    position: relative;
    margin: 15px 0 15px 20px;
    font-weight: 600;
    font-size: 16px;
    line-height: 1.4;
    color: #B9765B;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;

    &:before {
      content: '';
      width: 20px;
      height: 20px;
      margin-right: 5px;
      background-image: url("../../../../assets/images/icons/plus.svg");
      background-position: center center;
      background-size: contain;
    }
  }
}


@media screen and (max-width: 1170px) {
  .body {
    width: 100%;

    .whiteBg.client-side {
      margin-right: 0;
      padding: 0 !important;

      .wrap {
        padding: 0;
      }
    }
  }
  .card .master button {
    max-width: 100%;
  }
  .first_screen {
    margin-left: -15px;
    margin-right: -15px;
  }
}

h1 {
  display: none;
}

@media screen and (max-width: 991px) {
  h1 {
    display: block;
    font-size: 24px;
    line-height: 1.33;
    color: #383838;
    margin-bottom: 15px;
    margin-top: -10px;
    padding-top: 0;
  }
}
</style>
